import { Theme } from '@mui/material/styles';
//
import { CloseIcon } from './CustomIcons';

// ----------------------------------------------------------------------

declare module '@mui/material/styles' {
  interface CustomSize {
    large: string;
  }
  interface Palette extends CustomPalette {}
  interface PaletteOptions extends CustomPalette {}
}

declare module '@mui/material/Chip' {
  interface ChipPropsSizeOverrides {
    large: true;
  }
}

export default function Chip(theme: Theme) {
  return {
    MuiChip: {
      defaultProps: {
        deleteIcon: <CloseIcon />,
      },

      styleOverrides: {
        root: {
          ...theme.typography.badge,
          padding: theme.spacing(0.5),
          color: `${theme.palette.text.primary} !important`,
          '& .MuiSvgIcon-root': {
            width: 30,
            height: 30,
            background: 'transparent',
          }
        },
        sizeLarge: {
          fontSize: 14,
          height: theme.spacing(6),
          borderRadius: 50,
          '& .MuiSvgIcon-root': {
            marginLeft: theme.spacing(1),
            width: 35,
            height: 35,
          }
        },
        colorDefault: {
          backgroundColor: theme.palette?.branded?.paper,
          '& .MuiChip-avatarMedium, .MuiChip-avatarSmall': {
            color: theme.palette.text.secondary,
          },
          '&:hover': {
            backgroundColor: theme.palette?.branded?.paper,
          }
        },
        avatar: {
          padding: theme.spacing('4px', 0),
        },
        filled: {
          color: 'inherit',
        },
        outlined: {
          borderColor: theme.palette.grey[500_32],
          '&.MuiChip-colorPrimary': {
            borderColor: theme.palette.primary.main,
          },
          '&.MuiChip-colorSecondary': {
            borderColor: theme.palette.secondary.main,
          },
        },
        //
        avatarColorInfo: {
          color: theme.palette.info.contrastText,
          backgroundColor: theme.palette.info.dark,
        },
        avatarColorSuccess: {
          color: theme.palette.success.contrastText,
          backgroundColor: theme.palette.success.dark,
        },
        avatarColorWarning: {
          color: theme.palette.warning.contrastText,
          backgroundColor: theme.palette.warning.dark,
        },
        avatarColorError: {
          color: theme.palette.error.contrastText,
          backgroundColor: theme.palette.error.dark,
        },
      },
    },
  };
}
